export const countPathsEdges = [
  {
    id: "71.20.12.201-102.80.143.201",
    source: "102.80.143.201",
    target: "71.20.12.201",
    type: "straight",
  },
  {
    id: "10.5.112.134-71.20.12.201",
    source: "71.20.12.201",
    target: "10.5.112.134",
    type: "straight",
  },
  {
    id: "71.20.12.201-135.156.222.108",
    source: "71.20.12.201",
    target: "135.156.222.108",
    type: "straight",
  },
  {
    id: "10.5.112.134-135.156.222.108",
    source: "10.5.112.134",
    target: "135.156.222.108",
    type: "straight",
  },
  {
    id: "10.5.112.134-194.200.5.136",
    source: "10.5.112.134",
    target: "194.200.5.136",
    type: "straight",
  },
  {
    id: "102.80.143.201-194.200.5.136",
    source: "102.80.143.201",
    target: "194.200.5.136",
    type: "straight",
  },
  {
    id: "51.247.206.27-135.156.222.108",
    source: "51.247.206.27",
    target: "135.156.222.108",
    type: "straight",
  },
  {
    id: "51.247.206.27-71.20.12.201",
    source: "51.247.206.27",
    target: "71.20.12.201",
    type: "straight",
  },
];
